import { render } from "./AutenticMarket.vue?vue&type=template&id=68fafcd2&scoped=true"
import script from "./AutenticMarket.vue?vue&type=script&lang=js"
export * from "./AutenticMarket.vue?vue&type=script&lang=js"

import "./AutenticMarket.vue?vue&type=style&index=0&id=68fafcd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fafcd2"]])

export default __exports__